<template>
    <section class="main" v-loading="isLoading">
        <plat-form-component @updateData="updateData" :option="{dateRadio: false}"></plat-form-component>
        <section class="operate">
            <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate" @changeCompareDate="changeCompareDate" @downloadMenpiaoData="downloadMenpiaoData"></title-date-component>
            <section class="indicators-data-box">
                <indicators-data-component v-for="(item, index) in indicatorsData" :data="item" :key="index"></indicators-data-component>
            </section>
            <section class="data-box">
                <nav-component :type="type" :currentType="currentType" @changeNavType="changeNavType"></nav-component>
                <line-component style="width:95%; height:320px; margin-top:50px;" :resultData="lineResultData"></line-component>
                <table-component :tableInfo="tableInfo" style="margin-top:20px;"></table-component>
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 0;
    }
    .title-date {
        margin-top: 10px;
        padding: 0 20px;
    }
    .operate {
        width: 98%;
        background-color: #FFF;
        border-radius: 3px;
        overflow: hidden;
        margin-top: 60px;
        margin-left: 1%;
        .indicators-data-box {
            width: 100%;
            padding: 25px 20px;
        }
        .data-box {
            width: 100%;
            padding: 0 15px 40px 15px;
            margin-top: 35px;
        }
    }
</style>

<script>
    import PlatFormComponent from '../components/PlatForm.vue'
    import TitleDateComponent from '../../components/title-date/TitleDate.vue'
    import IndicatorsDataComponent from '../../components/indicators-data/IndicatorsData.vue'
    import NavComponent from '../../components/nav/Nav.vue'
    import LineComponent from '../../components/echarts/Line.vue'
    import TableComponent from '../../components/table/Table.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../filters/moment-format'
    import percentformat from '../../filters/percent-format'

    export default {
        components: {
            PlatFormComponent,
            TitleDateComponent,
            IndicatorsDataComponent,
            NavComponent,
            LineComponent,
            TableComponent
        },
        data () {
            const data = {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '经营分析',  // 名称
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    dateMaxRangeLength: 60, // 日期区间最大跨度
                    dateCompareSelect: true,
                    download: true, // 是否显示下载按钮
                    showDate: {
                        startDate: MomentFormat.getSevenDate(),
                        endDate: MomentFormat.getYestoday()
                    }
                },
                resultData: {},
                salePlatform: 0, // 平台
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
                type: [
                    {
                        name: '销售额',
                        value: 'payAmount'
                    },
                    {
                        name: '销售量',
                        value: 'payQuantity'
                    },
                    {
                        name: '消费券量',
                        value: 'consumeQuantity'
                    },
                    {
                        name: '访购率',
                        value: 'visitPurchaseRate'
                    },
                    {
                        name: '退款率',
                        value: 'refundRate'
                    }
                ],
                currentType: 'payAmount', // 当前纬度
                typeData: {
                    allTypeData: {  // 所有维度数据
                        payAmount: [],
                        payQuantity: [],
                        consumeQuantity: [],
                        visitPurchaseRate: [],
                        refundRate: []
                    },
                    allTypeCompareData: {   // 所有对比纬度数据
                        payAmount: [],
                        payQuantity: [],
                        consumeQuantity: [],
                        visitPurchaseRate: [],
                        refundRate: []
                    }
                },
                lineResultData: {
                    dateArr: [],
                    dataArr: [],
                    dateCompareArr: [],     // 对比日期
                    dataCompareArr: [],     // 对比数据
                    currentTypeName: '销售额'
                },
                tableInfo: {
                    title: [
                        {
                            name: '日期',
                            value: 'date'
                        },
                        {
                            name: '销售额',
                            value: 'payAmount'
                        },
                        {
                            name: '销售量',
                            value: 'payQuantity'
                        },
                        {
                            name: '消费券量',
                            value: 'consumeQuantity'
                        },
                        {
                            name: '退款量',
                            value: 'refundOrderNum'
                        },
                        {
                            name: '验证率',
                            value: 'consumeRate'
                        },
                        {
                            name: '退款率',
                            value: 'refundRate'
                        }
                    ],
                    data: []
                },
                isLoading: false
            }
            return data;
        },
        computed: {
            indicatorsData () {
                return {
                    payAmount: {
                        name: '销售额',
                        value: this.resultData.payAmount,
                        unit: '元',
                        compare: this.resultData.payAmountPercent,
                        title: '销售额'
                    },
                    payQuantity: {
                        name: '销售量',
                        value: this.resultData.payQuantity,
                        unit: '件',
                        compare: this.resultData.payQuantityPercent,
                        title: '销量'
                    },
                    consumeOrderNum: {
                        name: '消费券量',
                        value: this.resultData.consumeQuantity,
                        unit: '件',
                        compare: this.resultData.consumeQuantityPercent,
                        title: '验证的券量'
                    },
                    visitPurchaseRate: {
                        name: '访购率',
                        value: this.resultData.visitPurchaseRate,
                        unit: '%',
                        compare: this.resultData.visitPurchaseRatePercent,
                        title: '支付用户数/浏览用户数'
                    },
                    refundRate: {
                        name: '退款率',
                        value: this.resultData.refundRate,
                        unit: '%',
                        compare: this.resultData.refundRatePercent,
                        title: '用户申请退款的订单数/支付订单数'
                    }
                }
            }
        },
        methods: {
            getData (isCompare, date) {
                this.isLoading = true;
                menpiaoDataPlatform.getIndexData(this.salePlatform, date.startDate, date.endDate, true)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            if (!isCompare) {
                                this.resultData = res.data.sum === null ? {} : res.data.sum;
                            }
                            let data = res.data.daily === null ? [] : res.data.daily;
                            this.formatAllData(data, isCompare);
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        if (isCompare === true) {
                            this.lineResultData.dateCompareArr = [];
                            this.lineResultData.dataCompareArr = [];
                        } else {
                            this.lineResultData.dateArr = [];
                            this.lineResultData.dataArr = [];
                        }
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            formatAllData (data, isCompare) {
                let date = [];
                let initData = {
                    payQuantity: [],
                    payAmount: [],
                    consumeQuantity: [],
                    visitPurchaseRate: [],
                    refundRate: []
                };
                let arr = [];
                data.forEach((item) => {
                    date.push(item.date);
                    initData.payQuantity.push(item.payQuantity);
                    initData.payAmount.push(item.payAmount);
                    initData.consumeQuantity.push(item.consumeQuantity);
                    initData.visitPurchaseRate.push(item.visitPurchaseRate);
                    initData.refundRate.push(item.refundRate);
                    // table数据
                    let o = {};
                    o.date = {};
                    o.date.value = item.date;
                    o.payAmount = {};
                    o.payAmount.value = item.payAmount;
                    o.payQuantity = {};
                    o.payQuantity.value = item.payQuantity;
                    o.consumeQuantity = {};
                    o.consumeQuantity.value = item.consumeQuantity;
                    o.refundOrderNum = {};
                    o.refundOrderNum.value = item.refundOrderNum;
                    o.consumeRate = {};
                    o.consumeRate.value = percentformat(item.consumeRate, true);
                    o.refundRate = {};
                    o.refundRate.value = percentformat(item.refundRate, true);
                    arr.push(o);
                })
                if (isCompare === true) {
                    this.typeData.allTypeCompareData = initData;
                    this.$set(this.lineResultData, 'dateCompareArr', date);
                    this.$set(this.lineResultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
                } else {
                    this.typeData.allTypeData = initData;
                    this.$set(this.lineResultData, 'dateArr', date);
                    this.$set(this.lineResultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                    this.tableInfo.data = arr;
                }
            },

            // 更新数据
            updateData (params) {
                this.salePlatform = params.salePlatform;
                this.getData(false, this.date);
            },

            // 切换类型
            changeNavType (type) {
                this.currentType = type;
                let currentTypeName = this.type.find((item) => {
                    return item.value === this.currentType;
                });
                this.$set(this.lineResultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                this.$set(this.lineResultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
                this.$set(this.lineResultData, 'currentTypeName', currentTypeName.name);
                console.log(this.lineResultData);
            },

            // 切换日期
            changeDate (params) {
                this.date.startDate = params.dateRange.startDate;
                this.date.endDate = params.dateRange.endDate;
                this.getData(false, this.date);
            },

            // 切换对比日期
            changeCompareDate (params) {
                if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
                    this.lineResultData.dateCompareArr = [];
                    this.lineResultData.dataCompareArr = [];
                    return;
                }
                this.getData(true, params.dateRange);
            },

            // 下载
            downloadMenpiaoData () {
                menpiaoDataPlatform.downloadOperateData(this.salePlatform, this.date.startDate, this.date.endDate, true);
            }
        },
        created () {
            this.getData(false, this.date);
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?235b8963